import { Routes } from '@angular/router';

export const routes: Routes = [
	{
		path: 'home',
		loadComponent: () => import('./home/home-web.component').then((m) => m.HomeWebComponent),
	},
	{
		path: 'firma',
		loadChildren: () => import('./firma/firma-web.routes').then((m) => m.firmaWebRoutes),
	},
	{
		path: 'utenti-interni',
		loadComponent: () => import('./utenti/utenti-interni.component').then((m) => m.UtentiInterniWebComponent),
	},
	{
		path: 'utenti-esterni',
		loadComponent: () => import('./utenti/utenti-esterni.component').then((m) => m.UtentiEsterniWebComponent),
	},
	{
		path: 'storico-firmatario',
		loadComponent: () => import('./firma/firma-storico/firma-storico.component').then((m) => m.FirmaStoricoComponent),
	},
	{ path: '', redirectTo: 'home', pathMatch: 'full' },
];
